<div class="container">
    <div class="contenedor-datos-basicos">
        <p class="title-approbe">¡Haz tu compra ahora con Approbe! ¡Paga después!</p>
        <p class="text-approbe" > Ingresa tus datos para obtener tu cupo con Approbe </p>
        <app-form [controls]="controls$ | async" (sendInfo)="getInfoForm($event)"></app-form>
    </div>
</div>